export default "__VITE_ASSET__DbFuVcOO__"